import Vue from 'vue';
import VTooltip from 'v-tooltip';

Vue.use(VTooltip, {
  defaultBoundariesElement: document.body,
  defaultClass: 'my-tooltip',
});

export default {
  name: 'rating',
  props: ['rating'],
  data () {
    return {
      classQualityLevel: '',
      popoverValue: 0,
      selectedRatingValue: ['rating__popover'],
      popUpIsShown: false,
      popupTextValue: 'score',
    };
  },
  watch: {
    rating () {
      this.checkQualityLevel();
    },
  },
  updated () {
    this.checkQualityLevel();
  },
  mounted () {
    this.checkQualityLevel();
  },
  methods: {
    checkQualityLevel () {
      if (this.rating.Rating == this.rating.QualityLevel) {
        this.classQualityLevel = 'rating__current_normal';
      } else if (this.rating.Rating > this.rating.QualityLevel) {
        this.classQualityLevel = 'rating__current_good';
      } else if (this.rating.Rating < this.rating.QualityLevel) {
        this.classQualityLevel = 'rating__current_critical';
      } else {
        this.classQualityLevel = '';
      }
    },

    /**
         * Method for showing popup
         * @param {string} type - poupup type
         * @param {number} value - rating or score value
         */
    showRatingPopup (type, value) {
      if (this.popUpIsShown) {
        var removedClass = this.selectedRatingValue.pop();
        if (removedClass === type) {
          this.popUpIsShown = false;
          return;
        }
        this.selectedRatingValue.push(type);
        this.popupTextValue = type;
        this.popoverValue = value;
      } else {
        this.popUpIsShown = true;
        this.selectedRatingValue.push(type);
        this.popupTextValue = type;
        this.popoverValue = value;
      }
    },
  },
};
